import React, { FC, useState } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Grid, Box, TextField, InputAdornment } from '@mui/material';
import { Close, Search } from '@mui/icons-material';
import { FiltersButtons, FiltersLayout } from '../../../components';

interface IMissingTemplateLibraryFilters {
  isLoading: boolean;
  searchValue: string;
  setSearch: (val: string) => void;
}

export const MissingTemplateLibraryFilters: FC<IMissingTemplateLibraryFilters> = ({
  isLoading,
  searchValue,
  setSearch
}) => {
  const [hasAppliedFilters, setHasAppliedFilters] = useState<boolean>(false);
  const classes = useStyles();
  const [searchedValue, setSearchedValue] = useState('');
  return (
    <FiltersLayout>
      <Grid item xs={12} sm={4} lg={3}>
        <Box display="flex">
          <TextField
            size="small"
            fullWidth
            variant="outlined"
            placeholder="Search..."
            name="search"
            value={searchedValue}
            disabled={isLoading}
            InputProps={{
              startAdornment: (
                <InputAdornment
                  position="start"
                  className={classes.searchIcon}
                  onClick={() => {
                    if (searchValue.length > 0) {
                      setSearch(searchedValue);
                    }
                  }}
                >
                  <Search />
                </InputAdornment>
              ),
              endAdornment: searchValue ? (
                <InputAdornment
                  position="end"
                  className={classes.searchIcon}
                  onClick={() => {
                    setHasAppliedFilters(false);
                    setSearchedValue('');
                    setSearch('');
                  }}
                >
                  <Close />
                </InputAdornment>
              ) : null
            }}
            onKeyDown={e => {
              if (e.key === 'Enter' && searchedValue.length > 0) {
                setHasAppliedFilters(true);
                setSearch(searchedValue);
              }
            }}
            onChange={e => {
              setSearchedValue(e.target.value);
            }}
          />
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            setSearch(searchedValue);
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSearchedValue('');
            setSearch('');
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  searchIcon: {
    cursor: 'pointer',
    color: theme.palette.grey[500]
  }
}));
